// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608261104/js/" + chunkId + "." + {"44":"b0610671","225":"995c92b1","481":"19f6dc10","486":"253ac3f3","770":"9d413528"}[chunkId] + ".0.37916920658396447.chunk.js";
};